var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');

class PurchaseInformation extends React.Component {
    constructor(props) {
        super(props);

        this.getTotalPrice = this.getTotalPrice.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOptOutChange = this.handleOptOutChange.bind(this);
    }

    componentDidMount() {

    }

    getTotalPrice() {
        var stateDues = this.props.appState.stateComponentDuesOptOut ? 0 : this.props.appState.stateComponentDues;
        var districtDues = this.props.appState.stateComponentDuesOptOut ? 0 : this.props.appState.districtDues;
        return this.props.appState.membershipPrice + stateDues + districtDues;
    }

    handleOptOutChange(event) {
        this.props.updateApplicationState('stateComponentDuesOptOut', event.target.checked);
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.checked);
    }

    render() {
        var optOutClass = this.props.appState.stateComponentDuesOptOut ? ' opted-out' : '';
        var optOut = this.props.appState.stateComponentDues > 0 && this.props.appState.stateComponentDuesOptOutEligible
            ? <div className={"state-component-opt-out"}>
                <input type="checkbox" id="optoutcart" onChange={this.handleOptOutChange} checked={this.props.appState.stateComponentDuesOptOut} />
                <label className={"opt-out-label"} htmlFor={"optoutcart"}><small>{labels.cart.optOut}</small></label>
            </div>
            : null;

        var stateComponentmarkup = !this.props.appState.isInternational ? <div className={"purchase-item" + optOutClass}>
            <span className={"item"}>{labels.step6.stateComponentDues}</span>
            <span className={"cost"}>${this.props.appState.stateComponentDues}</span>
        </div> : null;
        const districtLabel = this.props.appState.primaryDistrictLocation ? ' (' + this.props.appState.primaryDistrictLocation + ')' : ''; //this.props.appState.districtProductTitle ? this.props.appState.districtProductTitle : '';

        var districtDuesMarkup = districtLabel ? <div className={"purchase-item" + optOutClass}>
            <span className={"item"}>{ "District Dues " + districtLabel}</span>
            <span className={"cost"}>${this.props.appState.districtDues}</span>
        </div> : null;

        var price = this.getTotalPrice();

        return <div className={"purchase-information-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step6.purchaseInformation}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-12"}>
                            <div className={"purchase-item"}>
                                <span className={"item"}>{this.props.appState.membershipProductTitleLongName}</span>
                                <span className={"cost"}>${this.props.appState.membershipPrice}</span>
                            </div>
                            {stateComponentmarkup}
                            {districtDuesMarkup}
                            <div className={"purchase-opt-out"}>
                                {optOut}
                            </div>
                            <div className={"purchase-total"}>
                                <span className={"item"}>{labels.step6.totalPrice}</span>
                                <span className={"cost"}>${price}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = PurchaseInformation;